import { Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { useEffect, useState } from 'react'
import Stat from 'src/components/mui/chip/stat'
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import { useGetInquiryQuery } from '../../store/inquiryApi'
import TableInquiry from '../../views/inquiry/TableInquiry'

const InquiryList = () => {
  const [total, setTotal] = useState(0);
  const { data, error } = useGetInquiryQuery({
    refetchOnFocus: true
  });
  
  useEffect(() => {
    data && setTotal(data.data)
  }, [data]);

  return (
    <Page title="Inquiry">
      <Grid container spacing={6}>
        <PageHeader
          title={
            <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 2}}>
                <Typography variant='h5' color='#666CFF'>
                  빠른 문의
                </Typography>
                <Stat value={total}/>
            </Stack>
          }
          subtitle={
            <Typography variant='body2'>
              빠른 문의 리스트를 보여줍니다.
            </Typography>
          }
        />
        <Grid item xs={12}>
          <TableInquiry />
        </Grid>
      </Grid>
    </Page>
  )
}

export default InquiryList